<script>
import { MessageBox } from 'element-ui'

/**
 * 考网风格的 alert (可参考 \src\demo\Demo.vue 中的用法)
 * @author wangk 2018-04-18T23:49:48+0800
 *
 * @method $alertSuccess(options[, elementUIOptions]) 成功 alert
 * @method $alertError(options[, elementUIOptions])   错误 alert
 * @method $kwAlert(options[, elementUIOptions])      原始 alert(默认成功)
 *
 * @todo 在页面显示 dialog 的情况下, z-index 有问题
 * @todo 「确定」按钮的颜色需要修改
 * @todo $alertSuccess 和 $alertError 的图标需要补上, 颜色也需要调整
 * @todo 打开、关闭的钩子(后期有需要再加)
 */
export default {
  install (Vue) {
    /**
     * 显示成功提示
     * @author wangk 2018-04-18T23:25:06+0800
     * @param  {Object} options [description]
     * @return {[type]}         [description]
     */
    Vue.prototype.$alertSuccess = function (options = { messages: ['成功啦！'] }, elementUIOptions = {}) {
      this.$kwAlert('success', options, elementUIOptions)
    }

    /**
     * 显示错误提示
     * @author wangk 2018-04-18T22:42:13+0800
     * @param  {Object} options { vnodes: false, messages: ['导入失败', '请下载错误文档'] }
     */
    Vue.prototype.$alertError = function (options = { messages: ['出错啦！'] }, elementUIOptions = {}) {
      this.$kwAlert('error', options, elementUIOptions)
    }

    /**
     * 显示考网风格的提示
     * @author wangk 2018-04-18T23:25:34+0800
     * @param  {String} type    success/error
     * @param  {Object} options { vnodes: false, messages: ['导入失败', '请下载错误文档'] }
     */
    Vue.prototype.$kwAlert = function (type = 'success', options, elementUIOptions) {
      const h = this.$createElement
      let boxShadowColor = '#67C23A'
      let icon = '√'
      if (type === 'error') {
        boxShadowColor = '#FCDEDE'
        icon = '×'
      }
      let childVnodes = [
        h('div', {
          'class': [`kw-alert__icon--${type}`],
          style: {
            width: '84px',
            height: '84px',
            borderRadius: '50%',
            boxShadow: `0 0 4px 4px ${boxShadowColor}`,
            marginBottom: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, icon)
      ]
      if (options.vnodes) {
        childVnodes.concat(options.messages)
      } else {
        options.messages.forEach(v => {
          childVnodes.push(
            h('div', {
              'class': 'kw-alert__tips'
            }, v)
          )
        })
      }

      let showConfirmButton = true
      if (elementUIOptions.showConfirmButton === false) {
        showConfirmButton = false
      }
      MessageBox({
        center: true,
        showClose: elementUIOptions.showClose || false,
        showCancelButton: elementUIOptions.showCancelButton || false,
        showConfirmButton,
        cancelButtonText: elementUIOptions.cancelButtonText || '取消',
        confirmButtonText: elementUIOptions.confirmButtonText || '我知道了',
        confirmButtonClass: elementUIOptions.confirmButtonClass || 'kw-alert__button--confirm',
        message: h('div', {
          'class': ['kw-alert', `kw-alert--${type}`],
          style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px'
          }
        }, childVnodes)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/KwAlert.vue